// extracted by mini-css-extract-plugin
export default {"wrapper":"R1-z","play":"S1-z"};